import React, { useState, useEffect } from 'react';
import painelApi, { getPainelToken, salvarSessaoPainel } from '../services/painelApi';
import { getToken } from '../utils/sessao';
import PainelLogin from './PainelLogin';
import PainelClientes from './PainelClientes';

// Login próprio (painel_usuarios), token e sessão numa chave própria do
// localStorage (sem relação com utils/sessao.js) — MAS com uma ponte de SSO:
// se o e-mail do usuário já logado no ERP bater com um painel_usuarios ativo
// (suporterb/ze compartilham o mesmo e-mail nos dois sistemas desde
// 2026-09-06, ver painelUsuariosController.sso), entra direto, sem pedir
// senha de novo. Renderizado como aba dentro do Layout (TabContext#ROTAS),
// visível só em rbdigital/jcr (ver Sidebar.jsx) — o backend segue sendo quem
// garante de verdade (404 em qualquer outro host).
export default function PainelClientesStandalone() {
  const [logado, setLogado] = useState(!!getPainelToken());
  const [tentandoSso, setTentandoSso] = useState(!logado);

  useEffect(() => {
    if (logado) return;
    let cancelado = false;
    painelApi.get('/painel-clientes/sso', {
      headers: { Authorization: `Bearer ${getToken()}` },
    })
      .then(({ data }) => {
        if (cancelado) return;
        salvarSessaoPainel(data.token, data.usuario);
        setLogado(true);
      })
      // Sem conta do painel vinculada a este login do ERP (ex.: entrou como
      // "Administrador") — cai no login manual normalmente, não é erro.
      .catch(() => {})
      .finally(() => { if (!cancelado) setTentandoSso(false); });
    return () => { cancelado = true; };
  }, [logado]);

  if (tentandoSso) return null;
  if (!logado) return <PainelLogin onEntrar={() => setLogado(true)} />;
  return <PainelClientes onSair={() => setLogado(false)} />;
}
